module.exports = __webpack_public_path__ + "static/media/test15.c33cb764.jpeg";